module.exports = __webpack_public_path__ + "img/1-2.ab66e110.png";